"use client";

import { useState } from "react";
import { Dialog, DialogPanel } from "@headlessui/react";
import {} from "@heroicons/react/24/outline";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import zeilbootIcon from "../assets/icons/zeilbootGrijs.png";
import zeilbootHome from "../assets/zeilboothome.png";
import motorbootIcon from "../assets/icons/motorbootGrijs.png";
import motorbootHome from "../assets/motorboothome.png";
import jetskiIcon from "../assets/icons/jetskiGrijs.png";
import jetskiHome from "../assets/jetskihome.png";
import ribIcon from "../assets/icons/ribGrijs.png";
import ribHome from "../assets/ribhome.png";
import waarborgenHome from "../assets/waarborgen1.jpg";
import Expertise from "../assets/icons/expertise.png";
import ContractOpMaat from "../assets/icons/contractopmaat.png";
import SnelEnSimpel from "../assets/icons/snelensimpel.png";
import AG from "../assets/ag-insurance-logo.png";
import AXA from "../assets/AXA.png";
import JeanVerheyen from "../assets/jeanverheyen.png";
import Sealogy from "../assets/sealogy.png";
import Pantaenius from "../assets/pantaenius.png";
import {
  CheckBadgeIcon,
  DocumentTextIcon,
  ForwardIcon,
  CheckCircleIcon,
  ShieldCheckIcon,
} from "@heroicons/react/20/solid";

import { useNavigate } from "react-router-dom";
import Verzekeringstool from "./Verzekeringstool";

export default function Example() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const [selectedBoatType, setSelectedBoatType] = useState(null);

  const handleSelectType = (type) => {
    setSelectedBoatType(type);
    navigate("/verzekeringsmodule", { state: { initialBoatType: type } });
  };

  const boottypes = [
    {
      type: "Zeilboot",
      imageUrl: zeilbootIcon,
    },
    {
      type: "Motorboot",
      imageUrl: motorbootIcon,
    },
    {
      type: "Jetski",
      imageUrl: jetskiIcon,
    },
    {
      type: "RIB",
      imageUrl: ribIcon,
    },
  ];

  const features = [
    {
      name: "Expertise",
      description:
        "Als verzekeringsmakelaar en schipper weten wij als geen ander wat jij nodig hebt om je vaartuig goed te verzekeren.",
      href: "#",
      icon: Expertise,
    },
    {
      name: "Contract op maat",
      description: "Elk vaartuig is uniek, uw verzekeringscontract dus ook.",
      href: "#",
      icon: ContractOpMaat,
    },
    {
      name: "Snel en simpel",
      description:
        "Doe in 5 minuten een aanvraag voor een offerte. Hulp nodig? Contacteer ons.",
      href: "#",
      icon: SnelEnSimpel,
    },
  ];

  const waarborgen = [
    {
      name: "Burgerlijke aansprakelijkheid",
      icon: ShieldCheckIcon,
    },
    {
      name: "Bescherming en verlies",
      icon: ShieldCheckIcon,
    },
    {
      name: "Lichtingskosten, hulp en berging",
      icon: ShieldCheckIcon,
    },
    {
      name: "Rechtsbijstand",
      icon: ShieldCheckIcon,
    },
    {
      name: "Persoonlijke ongevallen",
      icon: ShieldCheckIcon,
    },
  ];

  return (
    <div>
      <section>
        <main>
          <div className="relative isolate">
            <div className="overflow-hidden">
              <div className="mx-auto max-w-7xl px-6 pb-8 pt-8 sm:pt-20 lg:px-8 lg:pt-16">
                <div className="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
                  <div className="mx-auto max-w-2xl lg:mx-0 lg:flex-shrink-0 lg:pt-8">
                    <h1 className="mt-8 text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tight text-[#1a2a6c] text-left">
                      Uw <span className="text-[#ff6f61]">specialist</span> in
                      bootverzekeringen
                    </h1>

                    <p className="mt-8 text-lg font-medium text-[#1a2a6c] sm:text-xl/8 text-left">
                      Bij boot-verzekering.be zijn we gespecialiseerd in op maat
                      gemaakte verzekeringen voor uw vaartuig. Als schipper en
                      verzekeringsmakelaar hebben wij de dekkingen die jouw
                      vaartuig op het water houdt.
                    </p>
                    <div className="mt-10 flex items-center gap-x-6">
                      <a
                        href="/verzekeringsmodule"
                        className="rounded-md bg-[#1a2a6c] px-3.5 py-2.5 text-sm font-semibold text-[#ff6f61] shadow-sm hover:bg-[#142057] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1a2a6c]"
                      >
                        Vraag nu uw offerte aan
                      </a>
                    </div>
                  </div>

                  {/* Right Column - Images */}
                  <div className="hidden sm:grid mt-14 grid-cols-2 gap-8 sm:mt-0 lg:gap-10">
                    <div className="space-y-8 pt-12 lg:pt-20">
                      <div className="relative">
                        <img
                          alt="Zeilboot"
                          src={zeilbootHome}
                          className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                        />
                        <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                      </div>
                      <div className="relative">
                        <img
                          alt="Motorboot"
                          src={motorbootHome}
                          className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                        />
                        <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                      </div>
                    </div>

                    <div className="space-y-8">
                      <div className="relative">
                        <img
                          alt="Jetski"
                          src={jetskiHome}
                          className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                        />
                        <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                      </div>
                      <div className="relative">
                        <img
                          alt="RIB"
                          src={ribHome}
                          className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                        />
                        <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-gray-900/10" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </section>

      <section className="bg-[#efebe2] py-12 sm:py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:max-w-none">
            <div className="text-left">
              <h2 className="text-3xl font-semibold tracking-tight text-[#1a2a6c] sm:text-4xl">
                boot-verzekering.be{" "}
                <span className="text-[#ff6f61]">
                  in samenwerking met{" "}
                  <a
                    href="https://www.deins.be"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#ff6f61] underline hover:text-[#e65a56]"
                  >
                    Deins.be
                  </a>
                </span>
              </h2>
              <p className="mt-4 text-xl font-medium text-[#1a2a6c]">
                "uw zekerheid op het water"
              </p>
            </div>

            <div className="mt-8 text-left text-base sm:text-lg leading-relaxed text-[#1a2a6c]">
              <p>
                Wij begrijpen wat je boot voor jou betekent — en zorgen er
                persoonlijk voor dat jij onbezorgd het water op kan. Of het nu
                gaat om advies, een offerte of hulp bij schade: bij ons krijg je
                geen keuzemenu, maar een rechtstreeks contact met iemand die je
                écht helpt.
              </p>

              <p className="mt-8 font-semibold">
                Persoonlijk tot uw dienst, <br />
                Claes Jens <br />
                <a
                  href="https://www.deins.be"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#ff6f61] underline hover:text-[#e65a56]"
                >
                  Deins.be
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="py-12 sm:py-16">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:max-w-none">
              <div className="text-center">
                <h2 className="text-3xl font-semibold tracking-tight text-[#1a2a6c] sm:text-4xl">
                  Kies jouw type boot voor een{" "}
                  <span className="text-[#ff6f61]">snelle offerte</span>{" "}
                  aanvraag
                </h2>
              </div>
              <dl className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {boottypes.map((type) => (
                  <div
                    key={type.id}
                    onClick={() => handleSelectType(type.type)}
                    className="flex flex-col items-center text-center bg-[#1a2a6c] p-4 sm:p-6 lg:p-10 cursor-pointer rounded-lg hover:bg-[#142057]"
                  >
                    <img
                      src={type.imageUrl}
                      alt={`${type.type} afbeelding`}
                      className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 mb-4"
                    />
                    <dd className="text-xl sm:text-2xl lg:text-3xl font-semibold tracking-tight text-[#ff6f61]">
                      {type.type}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="py-12 sm:py-16">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:text-center">
              <h2 className="mt-2 text-3xl font-semibold tracking-tight text-[#1a2a6c] sm:text-4xl lg:text-balance">
                <span className="text-[#ff6f61]">Waarom</span>{" "}
                boot-verzekering.be?
              </h2>
            </div>
            <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
              <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
                {features.map((feature, index) => (
                  <div
                    key={feature.name}
                    className="flex flex-col items-start text-left h-full"
                  >
                    <div className="flex-shrink-0 mb-4">
                      <img
                        src={feature.icon}
                        alt={`${feature.name} icon`}
                        className="h-10 w-10"
                      />
                    </div>
                    <dt className="text-2xl font-bold text-[#1a2a6c]">
                      {feature.name}
                    </dt>
                    <dd className="mt-2 text-base leading-7 text-[#1a2a6c]">
                      {feature.description}
                    </dd>
                    <p className="mt-auto text-5xl font-bold text-[#ffb3a5]">
                      {String(index + 1).padStart(2, "0")}.
                    </p>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="flex items-center py-12 sm:py-16">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-8 sm:gap-y-10 lg:mx-0 lg:max-w-none lg:grid-cols-2">
              {/* Text Column Centered */}
              <div className="lg:mx-auto lg:pl-4 lg:pt-4">
                <div className="lg:max-w-lg">
                  <h2 className="mt-2 text-3xl font-semibold tracking-tight text-[#1a2a6c] sm:text-4xl">
                    Welke <span className="text-[#ff6f61]">waarborgen</span>{" "}
                    zijn mogelijk?
                  </h2>
                  <dl className="mt-6 max-w-xl space-y-6 text-base leading-7 text-[#1a2a6c] lg:max-w-none">
                    {waarborgen.map((feature) => (
                      <div key={feature.name} className="relative pl-9">
                        <dt className="inline font-semibold text-[#1a2a6c]">
                          <feature.icon
                            aria-hidden="true"
                            className="absolute left-1 top-1 h-5 w-5 text-[#1a2a6c]"
                          />
                          {feature.name}
                        </dt>{" "}
                        <dd className="inline">{feature.description}</dd>
                      </div>
                    ))}
                  </dl>

                  <div className="mt-6 text-left">
                    <a href="/informatie">
                      <button className="inline-flex items-center w-auto px-4 py-2 text-[#ff6f61] bg-[#1a2a6c] rounded-md shadow-md hover:bg-[#142057]">
                        Meer info?
                      </button>
                    </a>
                  </div>
                </div>
              </div>

              {/* Smaller Image */}
              <div className="flex items-start justify-end lg:order-first">
                <img
                  alt="Product screenshot"
                  src={waarborgenHome}
                  width={1200} // Adjusted width to make image smaller
                  height={800}
                  className="w-[32rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10 sm:w-[40rem]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="mx-auto max-w-7xl px-6 py-12 sm:py-16 lg:px-8">
          <h2 className="text-3xl font-semibold tracking-tight text-[#1a2a6c] sm:text-4xl">
            Bij <span className="underline">boot-verzekering.be</span> helpen
            wij jou navigeren naar{" "}
            <span className="text-[#ff6f61]">de beste verzekering</span> voor
            jouw vaartuig. Vraag nu jouw{" "}
            <span className="text-[#ff6f61]">offerte</span> aan!
          </h2>
          <div className="mt-10 flex items-center gap-x-6">
            <a
              href="/verzekeringsmodule"
              className="rounded-md bg-[#1a2a6c] px-5 py-3 text-base font-bold text-[#ff6f61] shadow-lg hover:bg-[#142057] hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1a2a6c]"
            >
              Ja, ik wil mijn vaartuig verzekeren
            </a>
          </div>
        </div>
      </section>

      <section>
        <div className="py-12 sm:py-16">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:max-w-none">
              <h2 className="text-3xl font-semibold tracking-tight text-[#1a2a6c] sm:text-4xl">
                Onze <span className="text-[#ff6f61]">partners</span> voor jouw
                bootverzekering
              </h2>

              <div className="mx-auto mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-y-10 gap-x-8">
                <img
                  alt="AG Insurance"
                  src={AG}
                  width={158}
                  height={48}
                  className="max-h-12 w-full object-contain"
                />
                <img
                  alt="AXA"
                  src={AXA}
                  width={158}
                  height={48}
                  className="max-h-12 w-full object-contain"
                />
                <img
                  alt="Jean Verheyen"
                  src={JeanVerheyen}
                  width={158}
                  height={48}
                  className="max-h-12 w-full object-contain"
                />
                <img
                  alt="Pantaenius"
                  src={Pantaenius}
                  width={158}
                  height={48}
                  className="max-h-12 w-full object-contain"
                />
                <img
                  alt="Sealogy"
                  src={Sealogy}
                  width={158}
                  height={48}
                  className="max-h-12 w-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
